import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useErrorMessage = apiErrorMessage => {
	const { t } = useTranslation('contractGenerator');

	const errorMessage = useMemo(() => {
		switch (apiErrorMessage) {
			case 501:
				return t('pages.step4.errorMessages.501');
			case 502:
				return t('pages.step4.errorMessages.502');
			case 503:
				return t('pages.step4.errorMessages.503');
			case 504:
				return t('pages.step4.errorMessages.504');
			case 505:
				return t('pages.step4.errorMessages.505');
			case 506:
				return t('pages.step4.errorMessages.506');
			case 507:
				return t('pages.step4.errorMessages.507');
			case 508:
				return t('pages.step4.errorMessages.508');
			case 515:
				return t('pages.step4.errorMessages.515');
			default:
				return t('pages.step4.errorMessages.unknown');
		}
	}, [apiErrorMessage]);

	return errorMessage;
};

export default useErrorMessage;
